import React, {Component} from 'react';

import { cf } from './cf';
import { ce } from './ce';
import { ic } from './ic';
import { bf } from './bf';

import cView from './cView';

class cCpyDtl extends cView {

  $id_stgs = {
  };

  $cd_stss = {
    s_cm20c310: '',
    s_cm20cz10: '10', // 表示対象
  };

  $clp_loads = () => [
    new Promise( _o_end1 => { // 利用者情報
      if (global.c?.state.sgc_pageMode == 'show') {
        //
        let _cnd = bf.q('[_KEY]={}'.f(global.c?.state.sgc_pageKey));
        cf.myCB_call_slc({
          ctr: 'nlm', 
          elm: 'cm20', 
          n_dms: 2, 
          cnd: _cnd
        })
        .then( _d_cm20s => {
          //
          global.c?.setState({
            sgcd_pagePntKeys: bf.p(global.c?.state.sgcd_pagePntKeys, _next => {
              _next.cm20_key = _d_cm20s._KEY;
              _next.cm20c310 = _d_cm20s.cm20c310;
            }),
          }, () => {
            global.c?.setState({ 
              s_cm20c310: _d_cm20s.cm20c310,
              s_cm20cz10: _d_cm20s.cm20cz10,
            }, ()=>{
              _o_end1();
            });
          });
        });
      }
      else {
        _o_end1();
      };
    }),
  ];

  $cp_ins = () => new Promise( (_o_end1) => {
    let _d_vals = {
      cm20c110: '',
    };
    let _cnd = '';
    cf.myCB_call_iud({
      ctr: 'ins', 
      elm: 'cm20', 
      d_vals: _d_vals, 
      cnd: _cnd
    })
    .then((_d_cm20s)=>{
      _o_end1(_d_cm20s);
    });
  });

  $clp_upds = () => [
    //
    new Promise( _o_end1 => {
      global.c.setState({
        sgcd_pagePntKeys: bf.p(global.c.state.sgcd_pagePntKeys, _next => {
          _next.cm20_key = global.c.state.sgc_pageKey;
          _next.cm20c310 = global.c.state.s_cm20c310;
        }),
      }, ()=>{
        _o_end1();
      });
    }),
    //
    new Promise( _o_end1 => {
      let _d_vals = {
        cm20c310: global.c.state.s_cm20c310,
        cm20cz10: global.c.state.s_cm20cz10,
      }
      let _cnd = bf.q('[_KEY]={}'.f(global.c.state.sgc_pageKey))
      cf.myCB_call_iud({
        ctr: 'upd', 
        elm: 'cm20', 
        d_vals: _d_vals, 
        cnd: _cnd
      })
      .then(()=>{
        _o_end1();
      });
    }),
  ];

  render() {
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_alwEdit={false}
        b_rhtVsb={true}
        rhtPfx={null}
        onRhtPrs={null}
        b_entBtnVsb={true}
        n_bdyW={ic.gn_maxBdyW}
        d_hdrs={global.c?.state.sgcd_hdrs}
        d_bdys={global.c?.state.sgcd_bdys}
      />
    );
  };
}

export default cCpyDtl;
